'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associateFileAttachmentsWithThread = undefined;

var _createAsyncAction = require('conversations-internal-clients/action-creators/createAsyncAction');

var _associateAttachmentsWithThreadClient = require('../clients/associateAttachmentsWithThreadClient');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var _buildResolvedAttachmentsMapFromResponse = require('../../resolved-attachments/operators/buildResolvedAttachmentsMapFromResponse');

/**
 * Create a mapping between file manager file ids and a live chat thread
 *
 * @param {Array<number>} fileIds
 * @param {number} threadId
 * @param {string} sessionId
 * @returns {Promise<Map<number, ResolvedAttachmentRecord>}
 */
var associateFileAttachmentsWithThread = exports.associateFileAttachmentsWithThread = (0, _createAsyncAction.createAsyncAction)({
  requestFn: _associateAttachmentsWithThreadClient.associateAttachmentsWithThreadClient,
  actionName: _fileUploadsActionTypes.ASSOCIATE_ATTACHMENTS,
  toRecordFn: _buildResolvedAttachmentsMapFromResponse.buildResolvedAttachmentsMapFromResponse
});


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/associateFileAttachmentsWithThread.js
// module id = 269
// module chunks = 2 3